export const Logo = () => {
  return (
    <div data-testid="logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="122.498"
        height="28"
        viewBox="0 0 122.498 28"
      >
        <g id="Group_702" data-name="Group 702" transform="translate(-40 -16)">
          <g
            id="Logo_Bug_-_4C_-_On_Dark"
            data-name="Logo Bug - 4C - On Dark"
            transform="translate(40 16)"
          >
            <g id="Group_697" data-name="Group 697">
              <path
                id="Path_815"
                data-name="Path 815"
                d="M22.507,121.4a4.812,4.812,0,0,1-7.285-3.4H6a14,14,0,0,0,22.434,10.461Z"
                transform="translate(-6 -103.3)"
                fill="#0076b6"
              />
              <g id="Group_696" data-name="Group 696">
                <path
                  id="Path_816"
                  data-name="Path 816"
                  d="M7.412,68.945A13.923,13.923,0,0,0,6,74.413h9.221a4.782,4.782,0,0,1,.257-1Z"
                  transform="translate(-6 -61.113)"
                  fill="#ebebec"
                />
                <path
                  id="Path_817"
                  data-name="Path 817"
                  d="M138.516,47.271l-6.638,6.4a4.808,4.808,0,0,1-.316,6l5.927,7.064a14,14,0,0,0,1.027-19.463Z"
                  transform="translate(-113.983 -42.473)"
                  fill="#ebebec"
                />
                <path
                  id="Path_818"
                  data-name="Path 818"
                  d="M81.083,22.271a4.8,4.8,0,0,1,3.829.921l6.638-6.4a14.018,14.018,0,0,0-13.47-3.242Z"
                  transform="translate(-67.989 -13)"
                  fill="#ebebec"
                />
                <path
                  id="Path_819"
                  data-name="Path 819"
                  d="M29.008,30.25A4.831,4.831,0,0,1,30.62,28.9l-3-8.722a14.048,14.048,0,0,0-6.676,5.6Z"
                  transform="translate(-18.849 -19.17)"
                  fill="#ebebec"
                />
              </g>
            </g>
          </g>
          <g
            id="Logo_Wordmark_-_On_Dark"
            data-name="Logo Wordmark - On Dark"
            transform="translate(78.498 23.179)"
          >
            <g id="Group_698" data-name="Group 698" transform="translate(0 0)">
              <path
                id="Path_820"
                data-name="Path 820"
                d="M473.234,73.907v4.375h-3.5V70.407h19.337a1.313,1.313,0,0,0,0-2.625H469.734v-3.5h19.337a4.813,4.813,0,0,1,0,9.625Z"
                transform="translate(-443.309 -64.282)"
                fill="#ebebec"
              />
              <path
                id="Path_821"
                data-name="Path 821"
                d="M301.739,73.694a4.822,4.822,0,0,0,3.212-3.287H284.484V67.782h20.467a4.813,4.813,0,0,0-4.63-3.5H280.984v14h3.5V73.907h13.695l3.456,4.375h3.5Z"
                transform="translate(-280.984 -64.282)"
                fill="#ebebec"
              />
              <path
                id="Path_822"
                data-name="Path 822"
                d="M682.672,67.782a1.312,1.312,0,0,1,1.313,1.313v9.188h3.5V69.094a4.812,4.812,0,0,0-4.812-4.812H660.8a4.812,4.812,0,0,0-4.812,4.813v9.188h3.5V69.094a1.312,1.312,0,0,1,1.313-1.312h9.188v10.5h3.5v-10.5Z"
                transform="translate(-603.484 -64.282)"
                fill="#ebebec"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
